define('connections/microshop-connection',['jquery', 'utils/ajax-util', 'settings'], function ($, ajax, settings) {
  /**
   * @class MicroshopConnection
   */
  return (function () {
    /**
     * @constructor
     */
    function MicroshopConnection() { }

    MicroshopConnection.prototype.getThemeColors = function (main, accent, lightness) {
      return ajax.get(settings.microshop + 'themecolors', {
        main: main,
        accent: accent,
        lightness: lightness
      });
    };

    MicroshopConnection.prototype.updateTheme = function (formData) {
      return ajax.ajaxWithFormData(settings.microshop + 'updatetheme', formData);
    };

    MicroshopConnection.prototype.updateContent = function (formData) {
      return ajax.ajaxWithFormData(settings.microshop + 'updatecontent', formData);
    };

    MicroshopConnection.prototype.updateOrderPriceSettings = function (formData) {
      return ajax.ajaxWithFormData(settings.microshop + 'updateorderpricesettings', formData);
    };

    MicroshopConnection.prototype.getOrderPriceSettings = function (shopId) {
      return ajax.get(settings.microshop + 'getorderpricesettings' + '?shopId=' + shopId);
    };

    MicroshopConnection.prototype.updateGeneral = function (formData) {
      return ajax.ajaxWithFormData(settings.microshop + 'updategeneralsettings', formData);
    };

    MicroshopConnection.prototype.updateFiles = function (formData) {
      return ajax.ajaxWithFormData(settings.microshop + 'updatefiles', formData);
    };

    MicroshopConnection.prototype.getFiles = function (shopId) {
      return ajax.get(settings.microshop + 'getFiles' + '?shopId=' + shopId);
    };

    MicroshopConnection.prototype.getProductSearchCategories = function (shopId) {
      return ajax.get(settings.microshop + 'getproductsearchcategories' + '?shopId=' + shopId);
    };

    MicroshopConnection.prototype.getProducts = function (shopId) {
      return ajax.get(settings.microshop + 'getproducts' + '?shopId=' + shopId);
    };

    MicroshopConnection.prototype.updateProducts = function (formData) {
      return ajax.ajaxWithFormData(settings.microshop + 'updateproducts', formData);
    };

    MicroshopConnection.prototype.getProductsBySearch = function (shopId, search, categories) {
      return ajax.get(
        settings.microshop +
        'getproductsbysearch' +
        '?shopId=' +
        shopId +
        '&search=' +
        search +
        (categories ? '&categories=' + categories : '')
      );
    };

    MicroshopConnection.prototype.getProductsByCategory = function (shopId, category) {
      return ajax.get(settings.microshop + 'getproductsbycategory' + '?shopId=' + shopId + '&category=' + category);
    };

    MicroshopConnection.prototype.getPrice = function (shopId, priceParams) {
      return ajax.get(settings.microshop + 'getprice' + '?shopId=' + shopId + '&' + priceParams);
    };

    MicroshopConnection.prototype.getProductsByWishList = function (shopId) {
      return ajax.get(settings.microshop + 'getproductsbywishlist' + '?shopId=' + shopId);
    };

    MicroshopConnection.prototype.addProducts = function (shopId, products) {
      return ajax.post(settings.microshop + 'addproducts', { shopId: shopId, products: products });
    };

    MicroshopConnection.prototype.validateUri = function (uriPart1, uriPart2, uriDomain, shopId) {
      return ajax.get(settings.microshop + 'validateUri', {
        uriPart1: uriPart1,
        uriPart2: uriPart2,
        uriDomain: uriDomain,
        shopId: shopId
      });
    };

    MicroshopConnection.prototype.removeShop = function (shopId) {
      return ajax.post(settings.microshop + 'removeshop', { shopId: shopId });
    };

    MicroshopConnection.prototype.getMicroshops = function () {
      return ajax.get(settings.microshop + 'microshoplist');
    };

    MicroshopConnection.prototype.removePendingOrders = function (shopId, ids) {
      return ajax.post(settings.microshop + 'removependingorders', { shopId: shopId, order_ids: ids });
    };

    MicroshopConnection.prototype.createMasterOrder = function (shopId, ids) {
      return ajax.post(settings.microshop + 'createmasterorder', { shopId: shopId, order_ids: ids });
    };

    MicroshopConnection.prototype.removeMasterOrder = function (shopId, orderId) {
      return ajax.post(settings.microshop + 'removemasterorder', { shopId: shopId, orderId: orderId });
    };

    return new MicroshopConnection();
  })();
});

